// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — header.classic.js, новая — header.cp.js
import { isCp } from 'libs/design';
import * as classic from './header.classic';
import * as cp from './header.cp';

export const Header = isCp ? cp.Header : classic.Header;
